module.exports = __webpack_public_path__ + "static/media/popularity_list.cf896fbf.png";